import Vue from 'vue';

const setAnswer = (state, answer) => {
  state.answers.push(answer);
};

const updAnswer = (state, payload) => {
  // console.log('updAnswer', payload.answer, payload.idx);
  Vue.set(state.answers, payload.idx, payload.answer);
};

const setPoll = (state, payload) => {
  state.answers.push(payload);
};

const setExelLink = (state, payload) => {
  state.exelLink = payload;
};

const removeAnswer = (state, idx) => {
  Vue.delete(state.answers, idx);
};

const removeAnswers = (state) => {
  state.answers = [];
};

const removeAnswersByPoll = (state, pollId) => {
  state.answers = state.answers.filter((o) => {
    return o.pollId !== pollId
  })
};

const updPhonePrefix = (state, payload) => {
  state.phonePrefix = payload;
};

export default {
  setAnswer,
  setExelLink,
  updAnswer,
  removeAnswer,
  removeAnswers,
  removeAnswersByPoll,
  setPoll,
  updPhonePrefix
}
